/**
 * Wait until the Document enters the interactive state
 * before triggering any of our initialization scripts.
 */
klevu.interactive(function() {
    klevuInit();
});
function klevuInit() {
    var options = {
        url : {
            landing : '/',
            protocolFull: klevu.settings.url.protocol + "//",
            
            // replace this with your own API Endpoint,
            // and include 'v2' in the subdomain for best performance,
            // eg. https://eucs18v2.ksearchnet.com/cs/v2/search
            search: klevu.settings.url.protocol + '//eucs18v2.ksearchnet.com/cs/v2/search'
        },
        localSettings: true,
        search: {
            minChars: 1,
            searchBoxSelector : "input.search-field" ,
            
            // replace this with your own JS API Key
            apiKey: "klevu-158264478226711692"
        }
    };

    klevu(options);
}

/**
 * We create a brand new event, named `MyFirstEvent`, which we can attach event listeners to.
 * You can rename this event to anything you like, as long as the event listeners are also updated.
 *
 * This event will execute from the time of creation for `maxCount` times with an interval
 * of `delay` or until the event evaluates to true via the fire function.
 * This allows us to check that everything is loaded before triggering the rest of our functionality.
 */
klevu.coreEvent.build({
    name : "MyFirstEvent",
    fire: function(){
        if (
            !klevu.isInteractive
            || klevu.isUndefined(klevu.search)
            || klevu.isUndefined(klevu.search.build)
            || klevu.isUndefined(klevu.searchEvents)
            || klevu.isUndefined(klevu.searchEvents.functions)
            || klevu.isUndefined(klevu.searchEvents.functions.bindAllSearchBoxes)
            || !klevu.getSetting(klevu.settings, "settings.localSettings", false)
        ) {
            return false;
        } else {
            return true;
        }
    },
    maxCount: 500,
    delay: 30
});

/**
 * When the above event fires, find and activate all search
 * input boxes based on the searchBoxSelector: "#search".
 */
klevu.coreEvent.attach("MyFirstEvent",{
    fire: function(){
        klevu.searchEvents.functions.bindAllSearchBoxes.fire();
    }
});

/**
 * We create another brand new event, named `MySecondEvent` this time.
 * This time we are waiting for all of our settings to be available from `klevuInitialise`.
 */
klevu.coreEvent.build({
    name: "MySecondEvent",
    fire: function () {
        if (
            klevu.isUndefined(klevu.search.extraSearchBox)
            || (klevu.search.extraSearchBox.length == 0)
        ) {
            return false;
        } else {
            return true;
        }
    },
    maxCount: 500,
    delay: 30
});

/**
 * When the above event fires, associate our auto-suggestion template
 * `KlevuTemplateAutoSuggestion` with all active search boxes on the page.
 * From hereon, this template will be referenced with the name `klevuAutoSuggestTarget`.
 *
 * There are other ways to inject this template, for example using fetch or AJAX requests,
 * but this one-page example uses an ID selector to get the HTML of the relevant template.
 */
klevu.coreEvent.attach("MySecondEvent", {
    fire: function () {
        klevu.each(klevu.search.extraSearchBox, function (key, box) {
            box.getScope().template.setTemplate(klevu.dom.helpers.getHTML("#KlevuTemplateAutoSuggestion"), "klevuAutoSuggestTarget", true);
        });
    }
});

/**
 * After the above event listener has run through it's code,
 * associate some functionality to the search boxes on the page.
 */
klevu.coreEvent.attach("MySecondEvent", {
    fire: function () {
        klevu.each(klevu.search.extraSearchBox, function (key, box) {
            /**
             * When a search request is built,
             * include a request for some auto-suggestion data.
             */
            box.getScope().chains.request.build.add({
                fire: function (data, scope) {
                    var parameterMap = klevu.getSetting(scope.kScope.settings, "settings.search.map", false);
                    var suggestion = klevu.extend(true, {}, parameterMap.suggestions);

                    suggestion.id = "autosuggestion";
                    suggestion.query = data.context.term;
                    suggestion.typeOfRequest = "AUTO_SUGGESTIONS";
                    suggestion.limit = 5;

                    data.request.current.suggestions.push(suggestion);
                    data.context.doSearch = true;
                }
            });

            /**
             * Also include some product results.
             */
            box.getScope().chains.request.build.add({
                fire: function (data, scope) {
                    var parameterMap = klevu.getSetting(scope.kScope.settings, "settings.search.map", false);
                    var myProductResults = klevu.extend(true, {}, parameterMap.recordQuery);

                    myProductResults.id = "myProductResults";
                    myProductResults.typeOfRequest = "SEARCH";
                    myProductResults.settings.query.term = data.context.term;
                    myProductResults.settings.typeOfRecords = ["KLEVU_PRODUCT"];
                    myProductResults.settings.limit = 5;
                    myProductResults.settings.sort = "RELEVANCE";

                    data.request.current.recordQueries.push(myProductResults);
                    data.context.doSearch = true;
                }
            });
            
            /**
             * Add another product query,
             * using some filters this time.
             */
            box.getScope().chains.request.build.add({
                fire: function (data, scope) {
                    var parameterMap = klevu.getSetting(scope.kScope.settings, "settings.search.map", false);
                    var myProductResults = klevu.extend(true, {}, parameterMap.recordQuery);

                    myProductResults.id = "mnhProducts";
                    myProductResults.typeOfRequest = "SEARCH";
                    myProductResults.settings.query.term = data.context.term;
                    myProductResults.settings.typeOfRecords = ["KLEVU_PRODUCT"];
                    myProductResults.settings.limit = 3;
                    myProductResults.settings.sort = "RELEVANCE";
                    myProductResults.filters.applyFilters.filters = [
                        {
                            key: "brand",
                            values: ["mnh"],
                            singleSelect: false
                        }
                    ];

                    data.request.current.recordQueries.push(myProductResults);
                    data.context.doSearch = true;
                }
            });

            /**
             * Add some CMS and Category records in various formats:
             * - CMS + Category
             * - CMS only
             * - Categories only
             */
            box.getScope().chains.request.build.add({
                fire: function (data, scope) {
                    var parameterMap = klevu.getSetting(scope.kScope.settings, "settings.search.map", false);
                    var cmsAndCats = klevu.extend(true, {}, parameterMap.recordQuery);

                    cmsAndCats.id = "cmsAndCats";
                    cmsAndCats.typeOfRequest = "SEARCH";
                    cmsAndCats.settings.query.term = data.context.term;
                    cmsAndCats.settings.typeOfRecords = ["KLEVU_CMS", "KLEVU_CATEGORY"];
                    cmsAndCats.settings.limit = 5;
                    cmsAndCats.settings.sort = "RELEVANCE";

                    data.request.current.recordQueries.push(cmsAndCats);
                    data.context.doSearch = true;
                }
            });
            box.getScope().chains.request.build.add({
                fire: function (data, scope) {
                    var parameterMap = klevu.getSetting(scope.kScope.settings, "settings.search.map", false);
                    var cmsOnly = klevu.extend(true, {}, parameterMap.recordQuery);

                    cmsOnly.id = "cmsOnly";
                    cmsOnly.typeOfRequest = "SEARCH";
                    cmsOnly.settings.query.term = data.context.term;
                    cmsOnly.settings.typeOfRecords = ["KLEVU_CMS"];
                    cmsOnly.settings.limit = 5;
                    cmsOnly.settings.sort = "RELEVANCE";

                    data.request.current.recordQueries.push(cmsOnly);
                    data.context.doSearch = true;
                }
            });
            box.getScope().chains.request.build.add({
                fire: function (data, scope) {
                    var parameterMap = klevu.getSetting(scope.kScope.settings, "settings.search.map", false);
                    var categoriesOnly = klevu.extend(true, {}, parameterMap.recordQuery);

                    categoriesOnly.id = "categoriesOnly";
                    categoriesOnly.typeOfRequest = "SEARCH";
                    categoriesOnly.settings.query.term = data.context.term;
                    categoriesOnly.settings.typeOfRecords = ["KLEVU_CATEGORY"];
                    categoriesOnly.settings.limit = 5;
                    categoriesOnly.settings.sort = "RELEVANCE";

                    data.request.current.recordQueries.push(categoriesOnly);
                    data.context.doSearch = true;
                }
            });

            /**
             * When a search result is rendered,
             * include our auto-suggestion template.
             */
            box.getScope().chains.template.render.add({
                fire: function (data, scope) {
                    if (data.context.isSuccess) {
                        scope.kScope.template.setData(data.template);
                        var targetBox = "klevuAutoSuggestTarget";
                        var element = scope.kScope.template.convertTemplate(scope.kScope.template.render(targetBox));
                        var target = klevu.getSetting(scope.kScope.settings, "settings.search.searchBoxTarget");
                        target.innerHTML = '';

                        scope.kScope.element.kData = data.template;
                        scope.kScope.template.insertTemplate(target, element);
                    }
                }
            });
        });
    }
});
